import React, { useContext, useEffect, useState } from "react";
import { getMoengage } from "../../utils/moengage.js";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
// import Loading from '../../components/advance/Loading';
// import Modal from '../../components/advance/Modal';
// import Accordian from '../../components/core/Accordian';
import Button from "../../components/core/EPL_Button_Think";
// import ErrorModal from '../../modals/ErrorModal';
// import { UserContext } from '../../shared/context/UserContext';
// import useMediaQuery from '../../shared/hooks/useMediaQuery';
import icon_modal from "../../assets/svg/EPL_think_svg/Icon_modal.svg";
import FloatingInput from "../../components/base/FloatingInput";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import CheckField from "../../components/form/CheckField";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { UserContext } from "../../shared/context/UserContext";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import ScenarioBasedModal from "../other-pages/Modals/ScenarioBasedModal";
import { AdditionalDetailsWrapper } from "./_styles/AdditionalDetailsWrapper";
// const getInternalStage = (stage, stage_status) => {
//   if (stage === 'ADDITIONAL_DETAILS' && stage_status === 'INIT') {
//     return 'ADDITIONAL_DETAILS_INIT';
//   } else if (stage === 'ADDITIONAL_DETAILS' && stage_status === 'COMPLETE') {
//     return 'ADDITIONAL_DETAILS_COMPLETE';
//   } else {
//     return 'ADDITIONAL_DETAILS_COMPLETE';
//   }
// };
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import {
  CKYC_DATASCIENCE,
  CKYC_POLLING,
  FACEMACTH,
  OKYC_CREATE_PROFILE,
  OKYC_DATASCIENCE,
  OKYC_POLLING,
  UPDATE_ADDRESS,
  ZUMIGO,
  NISHANDEH_GEOTAG
} from "../../Config";
import { updateLead } from "../../shared/services/crm";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidName } from "../../shared/validations/Name";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import {
  CkycFailedModal,
  CkycPollingFailedModal,
  DigilockerMovingModal,
  FaceMatchModal,
  OkycFailedModal,
} from "../other-pages/Modals/AllModal";
import { isStageLogin } from "../../shared/validations/StageLogin";
import poll from "../../utils/poll";
import { userConsentStatus } from "../../utils/userConsentStatus";
import { encryptedData } from "../../utils";

const VerifyDetails = () => {
  const moengage = getMoengage();
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("screen and (max-width: 768px)");

  const { user, setUser } = useContext(UserContext);
  // const applicationFormNumber = user.application_form_no;
  const [mobileNumber, setMobileNumber] = useState("");
  // const [internalStage, setInternalStage] = useState(
  //   getInternalStage(user.Stage.stage, user.Stage.stage_status)
  // );
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [internalStage, setInternalStage] = useState();

  // const [activeAccordian, setActiveAccordian] = useState('current_address');

  // const [modal, setModal] = useState('');
  const [onSubmitButtonDisabled, setOnSubmitButtonDisabled] = useState(false);
  const [loanAgreementConsent, setLoanAgreementConsent] = useState(false);
  const [additionalConfirm, setAdditionalConfirm] = useState("");
  const [addressType, setAddressType] = useState("OKYC");
  const [aadharAddressConfirm, setAadharAddressConfirm] = useState("");
  const [okycCalled, setOkycCalled] = useState();
  // Current Address
  const [currentAddress, setCurrentAddress] = useState("");
  const [currentPincode, setCurrentPincode] = useState();
  const [currentCity, setCurrentCity] = useState();
  const [currentState, setCurrentState] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showCkycFailedModal, setshowCkycFailedShowModal] = useState(false);
  const [showOkycFailedModal, setshowOkycFailedShowModal] = useState(false);
  const [showCkycPollingFailedModal, setShowCkycPollingFailedModal] =
    useState(false);
  const [sendToDigilocker, setSendToDigilocker] = useState(false);
  const [kycFLow, setKycFlow] = useState("OKYC");
  const [isFaceMatchFailed, setIsFaceMatchFailed] = useState(false);
  const source = location.pathname.split("/")[1];

  const [showShimmer, setShowShimmer] = useState(true);

  useEffect(() => {

    isStageLogin(   
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    // console.log(customerDetails);
    // setUrlApplicationNo(sessionStorage.getItem("application_form_no"));
    // var payload = {
    //   application_form_number: sessionStorage.getItem("application_form_no"),
    // };
    // try {
    //   console.log("getCUstomerDetails TRY BLOCK");
    //   const formData = new FormData();
    //   formData.append("data", encryptedData(payload));
    //   const response = await sendRequest(
    //     "/" + source + GET_CUSTOMER_DETAILS,
    //     formData
    //   );
    //   console.log("Response: ", response);
    //   if (response.response.Success) {
    //     // sessionStorage.setItem("abcplAuth", "authenticated");
    //     setCustomerDetails({
    //       ...customerDetails,
    //       application_form_number:
    //         response.response.Data.application_form_number,
    //       stage: response.response.Data.stage,
    //       Data: response.response.Data,
    //       source: source,
    //     });
    //     setInternalStage(response.response.Data.stage);
    //   }
    // } catch (error) {
    //   console.error(`Unknown Error: Constants Not Retireved - ${error}`);
    // }
    // console.log("INSIDE USEEFFECT OF ADDITIONAL");
    setInternalStage(customerDetails.stage);
    // window.scrollTo(0, 0);
    setLoanPurposeOptions(createLoanPurposeOptions());
  }, []);

  // console.log(customerDetails);

  useEffect(async () => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("AdditionalDetails customerDetails: ", customerDetails);
      // setShowShimmer(false);
      // TODO: Handle Staging if needed

      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      if (customerDetails?.Data?.isError === "True") {
        console.log(">>>><<<<<<<<<<");
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          if (customerDetails?.Data?.api_name === "okycPolling") {
            console.log(
              ">>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<"
            );
            await okycPolling();
          }
          if (customerDetails?.Data?.api_name === "okycCreateProfile") {
            console.log(
              ">>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<"
            );
            await createOkycProfile();
          }
          if (customerDetails?.Data?.api_name === "okycDataScience") {
            okycDataScience();
          }
          if (customerDetails?.Data?.api_name === "nishandeh_geotag"){
            nishandehGeotag();
          }
          // if (customerDetails?.Data?.api_name === "zumigoGetDistanceV2"){
          //   await zumigoCall();
          // }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      } else {
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    } else {
      // console.log("AdditionalDetails Ouch customerDetails ", location);
    }
  }, [customerDetails]);

  useEffect(async () => {
    // console.log("inside useEffect", internalStage);
    if (internalStage === "VERIFY_DETAILS_START") {
      setKycFlow("CKYC");
      await ckycPolling();
    } else if (internalStage === "OKYC_START") {
      // setLoad(false);
      setShowShimmer(true);
      // setCkycCallback(true);
      await createOkycProfile();
      // await okycPolling();
    } else if (internalStage === "OKYC_DONE") {
      setKycFlow("OKYC");
      // setLoad(false);
      if (customerDetails?.Data?.isError !== "True"){
        await okycPolling();
      }
    } else if (internalStage === "OKYC_PENDING") {
      setShowShimmer(true);
      await okycPolling();
    }
  }, [internalStage]);

  const ckycPolling = async () => {
    // setModal("LOADING");
    // history.replace({
    //   pathname: `/loan-ipo`,
    //   search: location.search,
    // });

    // console.log("INSIDE CKYCPOLLING OF ADDITIONAL");
    try {
      setShowShimmer(true);
      // console.log("callLivelinessAPI: inside try block");
      const formData = new FormData();
      const requestData = {};
      formData.append("data", encryptedData(requestData));
      const response = await poll(
        async () =>
          await sendRequest("/" + customerDetails.source + CKYC_POLLING,
            formData),
        ({ response }) => response.Success
      )
      // setShowShimmer(false);
      // console.log("callLivelinessAPI: response => ", response);

      if (response.response.Success === true) {
        if (response.response.Redirect === true) {
          setSendToDigilocker(true);
        } else {
          setShowShimmer(false);
          setCurrentAddress(response.response.Data.Address);
          setCurrentPincode(response.response.Data.PIN);
          setCurrentCity(response.response.Data.City);
          setCurrentState(response.response.Data.STATE);
          setMobileNumber(response.response.Data.MOBILENUMBER);
        }
        // something
      }
    } catch (error) {
      // if (customerDetails.source === "upsell") {
        updateLead(customerDetails.source, 127, customerDetails.application_form_number)
      // }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      // console.log("okyccreateprofile: inside catch block");
      setShowShimmer(false);
      // console.log("callLivelinessAPI: inside catch block");
    }
  };

  const createOkycProfile = async () => {
    // console.log(customerDetails, customerDetails.source);
    try {
      setShowShimmer(true);
      // console.log("createOkycProfile: inside try block");
      // console.log(
      //   "createOkycProfile: customerDetails.stage => ",
      //   customerDetails.stage
      // );
      const formData = new FormData();
      const requestData = {
        current_stage: "OKYC_START",
        stage_conditions: {
          ckycFailed: true,
        },
      };
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + OKYC_CREATE_PROFILE,
        formData
      );
      // setShowShimmer(false);
      // console.log("okyccreateprofile: response => ", response);

      if (response.response.Success === true) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            55,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            55,
            customerDetails.application_form_number
          );
        }
        // something
        window.open(response.response.Data.captureLink, "_self");
        // setShowShimmer(false);
        setOkycCalled(true);
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        setShowShimmer(false);
        // console.log("okyccreateprofile: inside catch block");
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          69,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          69,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      // console.log("okyccreateprofile: inside catch block");
    }
  };

  const okycPolling = async () => {
    // console.log("INSIDE OKYCPOLLING OF ADDITIONAL");
    try {
      // setShowShimmer(true);
      // console.log("OKYCPOLLING: inside try block");
      const formData = new FormData();
      const requestData = {
      };
      formData.append("data", encryptedData(requestData));
      const  response  = await poll(
        async () =>
          await sendRequest("/" + customerDetails.source + OKYC_POLLING,
            formData),
        ({ response }) => response.Success
      );
      // setShowShimmer(false);
      // console.log("OKYCPOLLING: response => ", response);

      if (response.response.Success === true) {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            56,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            56,
            customerDetails.application_form_number
          );
        }
        if (response.response.Redirect === true) {
          setInternalStage(response.response.STAGE);
        } else {
          // something
          setCurrentAddress(response.response.Data.Address);
          setCurrentPincode(response.response.Data.PIN);
          setCurrentCity(response.response.Data.City);
          setCurrentState(response.response.Data.STATE);
          setMobileNumber(response.response.Data.MOBILENUMBER);
          setShowShimmer(false);
        }
      } else if (response.response.Redirect) {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        if (response.response.Message === "PINCODE_VALIDATION_ERROR") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          70,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          70,
          customerDetails.application_form_number
        );
      }
      // setShowShimmer(false);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("callLivelinessAPI: inside catch block");
    }
  };

  const ckycDataScience = async () => {
    try {
      setShowShimmer(true);
      // console.log("ckycDataScience: inside try block");
      const formData = new FormData();
      const requestData = {};
      // setCustomerDetails({
      //   ...customerDetails,
      //   stage: "BANK_START",
      // });
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + CKYC_DATASCIENCE,
        formData
      );
      // setShowShimmer(false);

      // console.log("CKYC_DATASCIENCE: response => ", response);
      // navigate("/bank-details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //     // application_form_number: customerDetails.application_form_number
      //   },
      // });

      if (response.response.Success === true) {
        setShowShimmer(false);
        await nishandehGeotag();
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            78,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            78,
            customerDetails.application_form_number
          );
        }
        setshowCkycFailedShowModal(true);
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          68,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          68,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("okyccreateprofile: inside catch block");
    }
  };

  const okycDataScience = async () => {
    try {
      setShowShimmer(true);
      // console.log("ckycDataScience: inside try block");
      const formData = new FormData();
      const requestData = {
        kyc_flow: "OKYC",
        // current_stage: customerDetails.stage,
      };
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + OKYC_DATASCIENCE,
        formData
      );
      // setShowShimmer(false);
      // console.log("CKYC_DATASCIENCE: response => ", response);
      if (response.response.Success === true) {
        setShowShimmer(false);
        // console.log("success");
        // await faceMatch();
        await nishandehGeotag();
      } else {
        if (response.response.STAGE === "OCR_OKYC_REJECT") {
          console.log("Pan Aadhar Mismatch")
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: response.response.STAGE,
          });
          navigate(`${route}`, {
            replace: true,
          });
        }
        if (response.response.Message === "SUCCESS_REJECTED") {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              78,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              78,
              customerDetails.application_form_number
            );
          }
          setshowOkycFailedShowModal(true);
        }
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          70,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          70,
          customerDetails.application_form_number
        );
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("okyccreateprofile: inside catch block");
    }
  };

  const nishandehGeotag = async () => {
    try {
      setShowShimmer(true);
      const response = await sendRequest(
        "/" + customerDetails.source + NISHANDEH_GEOTAG, {}
      );
      if (response.response.Success === true) {
        setShowShimmer(false);
        await faceMatch();
      } else {
        if (response.response.Message === "Nishandeh reject") {
          setCustomerDetails({
            ...customerDetails,
            stage: response.response.STAGE
          });
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: response.response.STAGE,
          });
          navigate(`${route}`, {
            replace: true,
            state: {
              customerDetails: customerDetails,
            },
          });
        }
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  let ckycFailedStatus;
  let currentStage;

  const faceMatch = async () => {
    if (kycFLow === "CKYC") {
      ckycFailedStatus = false;
      currentStage = "VERIFY_DETAILS_START";
    } else {
      ckycFailedStatus = true;
      currentStage = "OKYC_DONE";
    }
    try {
      setShowShimmer(true);
      // console.log("callLivelinessAPI: inside try block");
      const formData = new FormData();
      const requestData = {
        kyc_flow: kycFLow,
        // current_stage: customerDetails.stage
        current_stage: currentStage,
        stage_conditions: {
          ckycFailed: ckycFailedStatus,
        },
      };
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + FACEMACTH,
        formData
      );
      // setShowShimmer(false);

      // console.log("CKYC_DATASCIENCE: response => ", response);
      // navigate("/bank-details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //     // application_form_number: customerDetails.application_form_number
      //   },
      // });
      if (response.response.Success === true) {
        if (customerDetails.source !== "upsell") {
          // await zumigoCall();
          updateLead(
            customerDetails.source,
            57,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            57,
            customerDetails.application_form_number
          );
        }
        setShowShimmer(false);
        // console.log("success");
        // something
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: response.response.STAGE,
        });
        // console.log("stage: ", customerDetails.stage);
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      } else {
        if (kycFLow === "CKYC") {
          createOkycProfile();
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              79,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              79,
              customerDetails.application_form_number
            );
          }
        } else {
          if (response.response.Message === "SUCCESS_REJECTED") {
            // API call to update  rejected state
            if (customerDetails.source === "upsell") {
              updateLead(
                customerDetails.source,
                79,
                customerDetails.application_form_number
              );
            } else {
              updateLead(
                customerDetails.source,
                79,
                customerDetails.application_form_number
              );
            }
            setIsFaceMatchFailed(true);
          }
        }
      }
    } catch (error) {
      if (kycFLow === "CKYC") {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            68,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            68,
            customerDetails.application_form_number
          );
        }
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            70,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            70,
            customerDetails.application_form_number
          );
        }
      }
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      // console.log("okyccreateprofile: inside catch block");
    }
  };

  const zumigoCall = async () => {
    // setLoad(true);
    // setShowShimmer(true);
    try {
      const formData1 = new FormData();
      const requestData1 = {
      };
      formData1.append("data", encryptedData(requestData1));
      try {
        // console.log("Inside try block");
        const { response } = await sendRequest(
          "/" + customerDetails.source + ZUMIGO,
          formData1
        );
        // console.log(response);
      } catch (error) {
        console.error(`Unknown Error: ${error}`);
      }
    } catch (error) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
      setShowShimmer(false);
      // console.log("okyccreateprofile: inside catch block");
    }
  };

  const addressApi = async (flow) => {
    moengage?.track_event("verify_address", {
      current_address_same_as_kyc: additionalConfirm === "Yes"? "Yes": "No",
      application_form_number: sessionStorage.getItem(
        "application_form_no"
      ),
      "journey name": customerDetails.source,
  });
    // console.log("loanPurpose: ", loanPurpose);
    // console.log("addressVerified: ", additionalConfirm);
    // setLoad(true);
    setShowShimmer(true);
    try {
      const formData1 = new FormData();
      const requestData1 = {
        full_address: currentAddress,
        pincode: currentPincode,
        city: currentCity,
        state: currentState,
        address_type: flow,
        verified: additionalConfirm,
        loan_purpose: loanPurpose,
        // current_stage: customerDetails.stage,
        // stage_conditions: {
        //   "ckycFailed": false
        // }
      };
      formData1.append("data", encryptedData(requestData1));
      try {
        // console.log("Inside try block");
        const { response } = await sendRequest(
          "/" + customerDetails.source + UPDATE_ADDRESS,
          formData1
        );
        // console.log(response);
        if (response.Success == true) {
          if (kycFLow === "CKYC") {
            ckycDataScience();
          } else {
            okycDataScience();
          }
        } else if(!response.Success && response.STAGE === "ADDRESS_REJECT") {
          /**
           * User is redirected to reject page if address validation fails
           */
          setCustomerDetails({
            ...customerDetails,
            stage: response.STAGE
          });
        }
      } catch (error) {
        if (kycFLow === "CKYC") {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              68,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              68,
              customerDetails.application_form_number
            );
          }
        } else {
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              70,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              70,
              customerDetails.application_form_number
            );
          }
        }
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
          setShowShimmer(false);
          // console.log("okyccreateprofile: inside catch block");
          console.error(`Unknown Error: ${error}`);
        }
      }
    } catch (error) {
      if (kycFLow === "CKYC") {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            68,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            68,
            customerDetails.application_form_number
          );
        }
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            70,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            70,
            customerDetails.application_form_number
          );
        }
      }
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        setShowShimmer(false);
        // console.log("okyccreateprofile: inside catch block");
      }
    }
  };

  const handleProceedClick = async ()=>{
    const payload = {
      kyc_agreement_to_correct_details: kycAgreementConsent, 
    }
    const src = customerDetails.source;

    await userConsentStatus(payload , src);
    await handleOnSubmit();
  }

  const handleOnSubmit = async () => {
    // console.log(additionalConfirm, aadharAddressConfirm);
    if (kycFLow === "CKYC") {
      if (additionalConfirm === "Yes") {
        // await ckycDataScience();
        await addressApi("CKYC");
      } else {
        if (aadharAddressConfirm === "Yes") {
          await createOkycProfile();
        } else {
          // Move to Rejected screen
          setCustomerDetails({
            ...customerDetails,
            stage: "rejected",
          });
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "rejected",
          });
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    } else {
      if (additionalConfirm === "Yes") {
        await addressApi("OKYC");
        moengage?.track_event("KYC Details", {
          journey_name: customerDetails.source,
          is_kyc_done: "yes",
          kyc_type: "OKYC",
        })
      } else {
        moengage?.track_event("KYC Details", {
          journey_name: customerDetails.source,
          is_kyc_done: "No",
          kyc_type: "OKYC",
        })
        setCustomerDetails({
          ...customerDetails,
          stage: "rejected",
        });
        // console.log("route: ", route);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "rejected",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
    }
  };

  const updateLoanAgreementConsent = () => {
    setLoanAgreementConsent(!loanAgreementConsent);
    setOnSubmitButtonDisabled(!onSubmitButtonDisabled);
  };

  const [consentCheckbox, setConsentCheckbox] = useState(false);

  const [urlApplicationNo, setUrlApplicationNo] = useState();

  const loanPurposes =
    customerDetails?.source === "epl"
      ? [
          "Purchase of consumer durables",
          "Education",
          "Travel",
          "Health",
          "Other consumption purposes",
        ]
      : [
          "Asset Acquisition",
          "Balance Transfer",
          "Education Purpose",
          "Family Celebration",
          "Family settlement",
          "Health and Wellness",
          "Home Renovation",
          "Medical Expense",
          "Purchase of fixed assets",
          "Vacation",
          "Others",
        ];

  const createLoanPurposeOptions = (isFilter = false, filterText = "") => {
    const options = [];
    // console.log("Creating Loan Purpose Options");
    // options.push(<option value="DEFAULT:disabled" key="disabled:Purpose of Loan" disabled>Purpose of Loan</option>);
    // for (let i = 0; i < loanPurposes.length; i++) {
    //     options.push(<option key={i+":"+loanPurposes[i]} value={loanPurposes[i]}>{loanPurposes[i]}</option>);
    // }
    // options.push({ label: "Purpose of Loan", value: "DEFAULT:disabled"});
    for (let i = 0; i < loanPurposes.length; i++) {
      if (
        isFilter &&
        loanPurposes[i]?.toLowerCase().indexOf(filterText.toLowerCase()) > -1
      ) {
        options.push({
          label: loanPurposes[i],
          value: loanPurposes[i],
          func: () => {
            setLoanPurpose(loanPurposes[i]);
            setLoanPurposeReq(false);
            showDropdown();
          },
        });
      } else if (!isFilter) {
        options.push({
          label: loanPurposes[i],
          value: loanPurposes[i],
          func: () => {
            setLoanPurpose(loanPurposes[i]);
            setLoanPurposeReq(false);
            showDropdown();
          },
        });
      }
    }
    if (options.length === 0) {
      options.push({
        label: "Not Found",
        value: "Not Found",
        func: () => {
          filterText = "";
          isFilter = false;
          setLoanPurpose("");
          showDropdown();
        },
      });
    }
    // for (let i = 0; i < loanPurposes.length; i++) {
    //     options.push({ label: loanPurposes[i], value: loanPurposes[i]});
    // }
    // console.log("Loan Purpose Options Created");
    return options;
  };

  const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);
  const [loanPurpose, setLoanPurpose] = useState();
  const [loanPurposePlaceholder, setLoanPurposePlaceholder] =
    useState("Purpose of Loan");
  var defaultLoanPurposePlaceholderStyle = {
    // width: "100%",
    // fontSize: "20px",
    // color: "red", // "var(--color-bw_americansilver)",
    // outline: "none",
    // backgroundColor: "transparent",// "var(--color-input-bg)",
    // transition: "all 0.1s ease",
    position: "absolute",
    // content: "${(props) => props.label}";
    width: "max-content",
    left: "0.75em",
    top: "50%",
    padding: "0px 0.25em",
    transform: "translateY(-50%)",
    color: "#717171", // var(--color-bw_black);
    border: "none",
    borderRadius: "2px",
    fontSize: "20px",
    pointerEvents: "none",
    transition: "all 0.3s ease",
  };
  const [loanPurposePlaceholderStyle, setLoanPurposePlaceholderStyle] =
    useState(defaultLoanPurposePlaceholderStyle);

  const loanPurposeDropdown = (filterText) => {
    // // console.log("loanPurpose Selected: ", selectedOption["value"]);
    // var e = document.getElementById("loanPurpose");
    // // console.log("loanPurpose e.value: ", e.value);
    // // console.log("loanPurpose e.options: ", e.options);
    // var value = e.value;
    // var text = e.options[e.selectedIndex].text;
    // // console.log(e.value);
    // // console.log("selectedOption: ", selectedOption.nativeEvent.data);
    // setLoanPurpose(selectedOption["value"]);
    setLoanPurpose(filterText);
    setLoanPurposeOptions(createLoanPurposeOptions(true, filterText));
    // // console.log("selectedOption: ", e.tartget.value);
  };

  const loanPurposeFocus = (event) => {
    // console.log("EVENT: ", event);
    // setLoanPurposePlaceholder("");
    var focusStyle = {
      top: "-0.5em",
      left: "0.25em",
      fontSize: "16px",
    };
    setLoanPurposePlaceholderStyle(focusStyle);
  };

  const loanPurposeBlur = (event) => {
    setLoanPurposePlaceholderStyle(defaultLoanPurposePlaceholderStyle);
  };

  const showDropdown = () => {
    document.getElementById("myDropdown").classList.toggle("show");
  };

  const allFieldsVerified = () => {
    return isValidName(loanPurpose) && confirmedAddress() && consentCheckbox
    && currentAddress.length > 0 && currentCity.length > 0 && currentState.length > 0 && currentPincode.length > 0;
  };

  const confirmedAddress = () => {
    if (kycFLow === "CKYC") {
      if (
        additionalConfirm === "Yes" ||
        (additionalConfirm === "No" &&
          ["Yes", "No"].includes(aadharAddressConfirm))
      )
        return true;
      return false;
    } else {
      if (additionalConfirm === "Yes" || additionalConfirm === "No")
        return true;
      return false;
    }
  };

  const updateAdditionalConfirm = (e) => {
    setAddConfirmReq(false);
    if(!loanPurposeReq){
      setAddConfirmError(false);
    }
    setAdditionalConfirm(e.target.value);
    setAadharAddressConfirm("");
  };

  const updateAadharAddressConfirm = (e) => {
    if (e.target.value == "Yes") {
      setShowModal(true);
    }
    setAadharAddressConfirm(e.target.value);
  };

  useEffect(() => {
    setAddConfirmError(false);
  }, [additionalConfirm])

  useEffect(() => {
    setPurposeConfirmError(false);
  }, [loanPurpose])
  
  const [loanPurposeReq, setLoanPurposeReq] = useState(true);
  const [addConfirmReq, setAddConfirmReq]= useState(true);
  const [addConfirmError, setAddConfirmError] = useState(false);
  const [purposeConfirmError, setPurposeConfirmError] = useState(false);
  const [kycAgreementConsent, setKycAgreementConsent] = useState(false)

  const updateConsentBox = () => {    
    if(!loanPurposeReq && !addConfirmReq){
      setKycAgreementConsent(!kycAgreementConsent);
        setConsentCheckbox(!consentCheckbox);
       setPurposeConfirmError(false);
        setAddConfirmError(false);
    }
    if(addConfirmReq){
      setAddConfirmError(true);
    }
    if(loanPurposeReq){
      setPurposeConfirmError(true);
    }
    // setConsentCheckbox(!consentCheckbox);
  };

  return (
    <>
      <ProgressBar showProgress={true} currentStep={4} showText={false} />
      <AfterLoginLayoutWrapper>
        <CkycFailedModal
          isOpen={showCkycFailedModal}
          onClose={async () => {
            setshowCkycFailedShowModal(false);
            await createOkycProfile();
          }}
          modalImage={icon_modal}
        />
        <OkycFailedModal
          isOpen={showOkycFailedModal}
          onClose={async () => {
            setshowOkycFailedShowModal(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
          modalImage={icon_modal}
        />
        <CkycPollingFailedModal
          isOpen={showCkycPollingFailedModal}
          onClose={async () => {
            setShowCkycPollingFailedModal(false);
            await createOkycProfile();
            // var route = getRouteFromLoanStageService({
            //   source: customerDetails.source,
            //   stage: "rejected",
            // });
            // navigate(`${route}`, {
            //   replace: true,
            // });
          }}
          modalImage={icon_modal}
        />
        <ScenarioBasedModal
          id="bd-modal"
          modalImage={icon_modal}
          isOpen={showModal}
          showCloseButton={false}
          onClose={() => {
            setShowModal(false);
          }}
          modalMessageHeading={"Keep your Aadhar number ready"}
          modalMessage="Hope your current address is updated in your AADHAR"
          modalSubmitMessage="Click to Proceed"
          style={{ borderRadius: "20px" }}
          onModalSubmit={() => {
            setShowModal(false);
          }}
        />
        <DigilockerMovingModal
          isOpen={sendToDigilocker}
          onClose={async () => {
            await createOkycProfile();
            setSendToDigilocker(false);
          }}
          modalImage={icon_modal}
        />

        <FaceMatchModal
          isOpen={isFaceMatchFailed}
          onClose={() => {
            setIsFaceMatchFailed(false);
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "rejected",
            });
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
            });
          }}
          modalImage={icon_modal}
        />

        <AdditionalDetailsWrapper className="first-child">
          <ShimmerPlaceholder
            visible={showShimmer}
            height="2em"
            width="12em"
            marginTop="1em"
          />
          <div className="additional-form-title">
            <Title
              text={`Confirm your Details`}
              visible={!showShimmer}
              clickable={false}
            />
          </div>
          <form className="additional-form">
            <ShimmerPlaceholder visible={showShimmer} />
            <FloatingInput
              visible={!showShimmer}
              // on_change={(e) => {
              //   loanPurposeDropdown(e.target.value);
              // }}
              value={loanPurpose}
              type={"text"}
              label="Purpose of Loan"
              options={loanPurposeOptions}
            />

            {purposeConfirmError? 
                <div className="purposeConfirm">
                  <p style={{marginBottom:"0"}}>Please confirm purpose of loan before proceeding</p>
                </div>:<></>}
                
            {!showShimmer ? (
              <>
                <div className={"check-details-line"}>
                  {kycFLow === "CKYC"
                    ? "We fetched the following information from CERSAI. Please verify these details:"
                    : "We fetched the following information from DigiLocker. Please verify these details:"}
                </div>
                <div className="additional-details-card">
                  <span className="heading">Current Address</span>
                  <span>{currentAddress}</span>
                  <div>
                    <span>PinCode</span>
                    <span>{currentPincode}</span>
                  </div>
                  <div>
                    <span>City</span>
                    <span>{currentCity}</span>
                  </div>
                  <div>
                    <span>State</span>
                    <span>{currentState}</span>
                  </div>
                  <div>
                    <span>Mobile Number</span>
                    <span>+91 {mobileNumber}</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="45px"
                  marginTop="0.5em"
                />
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="180px"
                  marginTop="0.5em"
                />
              </>
            )}
          </form>
          {!showShimmer ? (
             <>
            <div className="additional-details-card additional-confirm">
              <div className="sub-title">
                <SubTitle
                  text="Is this your current address?"
                  style={{
                    textAlign: "left",
                    padding: "0px",
                  }}
                />
              </div>
              <form className="radio-buttons">
                <input
                  type="radio"
                  id="additional-yes"
                  name="confirm-additional-detail"
                  checked={additionalConfirm === "Yes"}
                  value={"Yes"}
                  onChange={updateAdditionalConfirm}
                />
                <label for="additional-yes">Yes</label>
                <input
                  type="radio"
                  id="additional-no"
                  name="confirm-additional-detail"
                  checked={additionalConfirm === "No"}
                  value={"No"}
                  onChange={updateAdditionalConfirm}
                />
                <label for="additional-no">No</label>
              </form>
            </div>
            
            {addConfirmError? 
              <div className="addConfirm">
                <p>Please confirm address before proceeding</p>
              </div>:<></>}

          </>
          ) : (
            <>
              <ShimmerPlaceholder
                visible={showShimmer}
                height="50px"
                marginTop="0.5em"
              />
            </>
          )}
          {!showShimmer && additionalConfirm === "No" && kycFLow === "CKYC" ? (
            <div className="additional-details-card additional-confirm">
              <div className="sub-title">
                <SubTitle
                  text="Is your current address updated with Aadhaar?"
                  style={{
                    textAlign: "left",
                    padding: "0px",
                  }}
                />
              </div>
              <form className="radio-buttons">
                <input
                  type="radio"
                  id="additional-yes-2"
                  name="confirm-additional-detail"
                  checked={aadharAddressConfirm === "Yes"}
                  value={"Yes"}
                  onChange={updateAadharAddressConfirm}
                />
                <label for="additional-yes-2">Yes</label>
                <input
                  type="radio"
                  id="additional-no-2"
                  name="confirm-additional-detail"
                  checked={aadharAddressConfirm === "No"}
                  value={"No"}
                  onChange={updateAadharAddressConfirm}
                />
                <label for="additional-no-2">No</label>
              </form>
            </div>
          ) : (
            <></>
          )}
          <div className={"additional-form-img bottomDiv"}>
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="3em"
                  width="23em"
                />
              </>
            ) : (
              <>
                <CheckField
                  id="basic-ckeckfield"
                  checked={consentCheckbox}
                  label="By clicking proceed, you agree that the details provided on the screen are correct."
                  style={{
                    fontSize: "15px",
                  }}
                  // onClick={() => {
                  //   setConsentCheckbox(!consentCheckbox);
                  // }}
                  onClick={updateConsentBox}
                />
              </>
            )}
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  visible={showShimmer}
                  height="3em"
                  width="9em"
                />
              </>
            ) : (
              <>
                <Button
                  id="ProceedBtn"
                  className="Btn ProceedBtn"
                  disabled={!allFieldsVerified()}
                  mobile={isMobile}
                  onClick={
                    handleProceedClick
                  }
                  text={"Proceed"}
                />
              </>
            )}
          </div>
        </AdditionalDetailsWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default VerifyDetails;
